// extracted by mini-css-extract-plugin
export default {"Container":"sixYardBreif_Container__n18+b","Description":"sixYardBreif_Description__HW1vS"};